import { render, staticRenderFns } from "./SensorUpdateForm.vue?vue&type=template&id=084f696a&scoped=true&"
import script from "./SensorUpdateForm.vue?vue&type=script&lang=ts&"
export * from "./SensorUpdateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f696a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
